import { useEffect } from "react";

function Facilities() {
  useEffect(() => {
    document.title ="Facilities";
  });

  return (
    <div class="content">
      <div class="w-container">
        <div class="page-head">
          <div class="page-title">
            <h1 class="h1">
              Our Facilities
            </h1>
          </div>
          <div class="flex-vert">
            <div class="sub-hrule"></div>
            <p class="paragraph-center sub">
              Wiess is designed to keep our students comfortable and
              productive, with plenty of spaces to both have fun and
              socialize, as well as get work done.
            </p>
          </div>
        </div>
        <div class="flex-vert">
          <h3 class="h3">The Main Building</h3>
          <div class="sub-hrule"></div>
          <p class="paragraph-center sub">
            Our main building was completed in 2002 to replace "Old 
            Wiess," which had been housing Wiessmen since 1949. The
            college encloses a large academic quadrangle, known as
            the Acabowl. North of the Acabowl is the glass-walled
            Commons, the main gathering space of Wiessmen. The other
            three sides of the Acabowl are lined with four-story
            residence wings, with dormitories and other facilities.
            Outside the Commons is
            home to our comfortable Acagliders, outdoor seating,
            hammocks, grills, and a fire pit. The other side of the
            Commons adjoins South Servery, which serves both Wiess
            and Hanszen College.
          </p>
          <div class="gallery">
            <img src="/images/new-students/commons.jpg" alt="Wiess Commons" />
            <img src="/images/new-students/acabowl.jpg" alt="Wiess acabowl" />
            <img src="/images/about/Stairs.jpg" alt="Wiess stairs" />
            <img src="/images/about/Acabowl2.jpg" alt="Wiess acabowl" />
            <img src="/images/about/Acagliders.jpg" alt="Wiess acagliders" />
            <img src="/images/about/Acaterrace.jpg" alt="Not actually acaterrace" />
          </div>
          <h3 class="h3" style={{ marginTop: "40px" }}>Student Dormitories</h3>
          <div class="sub-hrule"></div>
          <p class="paragraph-center sub">
            Wiessmen typically live in four-person suites. These can be 
            either suites holding two doubles (usually for freshmen),
            or suites with four singles. There are some "three-man" suites 
            on the west wing, which each hold three people, as well
            as "five-man" suites on the east wing, each holding
            five people. Each suite has a spacious common room and a 
            dedicated bathroom.
          </p>
          <div class="gallery">
            <img src="/images/new-students/hall.jpg" alt="Wiess hall" />
            <img src="/images/new-students/alcove.jpg" alt="Wiess alcove" />
            <img src="/images/new-students/beds.jpg" alt="Wiess beds" />
            <img src="/images/new-students/onedesk.jpg" alt="Wiess desk" />
            <img src="/images/new-students/desks.jpg" alt="Wiess desks" />
            <img src="/images/new-students/bathroom.jpg" alt="Wiess bathroom" />
          </div>
          <h3 class="h3" style={{ marginTop: "40px" }}>Other Spaces</h3>
          <div class="sub-hrule"></div>
          <p class="paragraph-center sub">
            Wiess houses various unique facilities to support students'
            studying, socializing, and interests. These include our 
            upper commons (UpCo), movie room, kitchens, resident
            associate suites, computer lab, dance room, and off-campus
            (O/C) lounge.
          </p>
          <div class="gallery" style={{ marginBottom: "40px" }}>
            <img src="/images/about/Upco.jpg" alt="Wiess upper commons" />
            <img src="/images/about/Classroom.jpg" alt="Wiess classroom" />
            <img src="/images/about/Comp.jpg" alt="Wiess computer room" />
            <img src="/images/about/Laundry.jpg" alt="Wiess laundry room" />
            <img src="/images/about/Music.jpg" alt="Wiess music room" />
            <img src="/images/about/Movie.jpg" alt="Wiess movie room" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Facilities;